import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const marketplace: ThemeApp['appComponents']['marketplace'] = {
  accessManagement: {
    apiKeys: {
      integrationToolsLinks: {
        color: themeUi.semantic.color.text.secondary200
      },
      divider: {
        backgroundColor: themeUi.semantic.color.background.secondary800
      }
    }
  },

  accountMapping: {
    imageContainer: {
      backgroundColor: themeUi.semantic.color.background.secondary990
    },
    accountMapping: {
      formContainer: {
        backgroundColor: themeUi.semantic.color.background.secondary950,
        boxShadow: 'none',
        border: `1px solid ${themeUi.semantic.color.border.secondary800}`,
        color: themeUi.semantic.color.text.secondary0
      },
      heading: {
        color: themeUi.semantic.color.text.secondary0
      },
      subheading: {
        disabledColor: themeUi.semantic.color.text.secondary500,
        normalColor: themeUi.semantic.color.text.secondary200
      },
      divider: {
        backgroundColor: themeUi.semantic.color.background.secondary800
      },
      noEligibleAccountsSubheading: {
        color: themeUi.semantic.color.text.secondary200
      }
    },

    accountsRadio: {
      accountsRadioGroup: {
        accountName: {
          color: themeUi.semantic.color.text.secondary0,
          disabledColor: themeUi.semantic.color.text.secondary500
        }
      }
    },

    mappingFooter: {
      setupLaterModalSubheading: {
        color: themeUi.semantic.color.text.secondary200
      }
    }
  },

  freeTrial: {
    imageContainer: {
      backgroundColor: themeUi.semantic.color.background.secondary990
    },
    formContainer: {
      backgroundColor: themeUi.semantic.color.background.secondary950,
      boxShadow: 'none',
      border: `1px solid ${themeUi.semantic.color.border.secondary800}`,
      color: themeUi.semantic.color.text.secondary0
    },
    heading: {
      color: themeUi.semantic.color.text.secondary0
    },
    subheading: {
      color: themeUi.semantic.color.text.secondary200
    },
    details: {
      color: themeUi.semantic.color.text.secondary400
    }
  }
};
